import script from "./trade-and-earn.vue?vue&type=script&lang=ts&setup=true"
export * from "./trade-and-earn.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__